import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import Gallery from './components/Gallery';
import Music from './components/Music';
import Audiovisual from './components/Audiovisual';
import WrittenWorks from './components/WrittenWorks';
import SpecialProjects from './components/SpecialProjects';
import Biography from './components/Biography';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CookieConsent from './components/CookieConsent';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <Highlights />
      <Gallery />
      <Music />
      <Audiovisual />
      <WrittenWorks />
      <SpecialProjects />
      <Biography />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <CookieConsent />
    </div>
  );
}

export default App;
